import React from 'react'

import DataTable from '../../../components/table/DataTable'

const INVENTORY_COLUMNS = [
  { key: 'product_db_ref', label: 'CÓDIGO' },
  { key: 'barcode', label: 'COD. DE BARRA' },
  { key: 'product_name', label: 'NOMBRE DEL PRODUCTO' },
  { key: 'package_unit', label: 'EMPAQUE' },
  { key: 'inventory_quantity', label: 'INVENTARIO' }
]

export default function PosTaskInventoryReport({ activity }) {
  const rows = (activity.details || []).map((product, index) => ({
    id: product.id || `${product.product_db_ref || 'product'}-${index}`,
    product_db_ref: product.product_db_ref || '-',
    barcode: product.product_barcode || product.product_db_ref || '-',
    product_name: product.product_name || '-',
    package_unit: product.package_unit || '-',
    inventory_quantity:
      product.inventory_quantity !== undefined && product.inventory_quantity !== null
        ? product.inventory_quantity
        : '-'
  }))

  return (
    <DataTable
      compact
      ariaLabel="Detalles de inventario"
      columns={INVENTORY_COLUMNS}
      rows={rows}
      emptyState={{
        title: 'Sin productos',
        description: 'Esta captura de inventario no tiene productos reportados.'
      }}
    />
  )
}
